// Recurring donation detail page (CHG-1240 / ITER-3363).
//
// Thin per the v8 brief: ≤30 LOC. All configuration in @generated/screens.
// Future generator regenerates recurringDonationDetailConfig from
// recurring-donation.entity-hint.yaml (CHG-1228) without touching this
// file.
//
// Spec: specs/tier-05-experience/recurring-donation-detail-v2.cross-screen.yaml.

import { DetailPage } from "../components/composition";
import { recurringDonationDetailConfig } from "../generated/screens/recurring-donation-detail";

export function RecurringDonationDetail() {
  return <DetailPage config={recurringDonationDetailConfig} />;
}
